import React, { useContext, useEffect, useState } from 'react';
import type { FC, PropsWithChildren } from 'react';
import Box from '@mui/material/Box';

import { AppContext } from '../../../capabilities/contextStore/AppContext';
import useContainerCloseHandler from '../hooks/useContainerCloseHandler';

const InlineContainer: FC<PropsWithChildren> = ({
  children,
}) => {
  const [closeContent, setCloseContent] = useState(false);
  const { headerTitleId } = useContext(AppContext);

  const { shouldCloseContainer } = useContainerCloseHandler();

  useEffect(() => {
    setCloseContent(shouldCloseContainer);
  }, [shouldCloseContainer]);

  if (closeContent) {
    return null;
  }

  return (
    <Box
      position="relative"
      aria-labelledby={headerTitleId}
    >
      {children}
    </Box>
  );
};

export default InlineContainer;
